import LargeHeadingBlock from './largeHeadingBlock';

export default LargeHeadingBlock;
